
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogg/[slug]",
      function () {
        return require("private-next-pages/blogg/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogg/[slug]"])
      });
    }
  